import { GetStaticProps } from 'next';

import { useUserStore } from '@/modules/user/userStore';
import { Page } from '@/ui/layout/Page';
import { PageTitle } from '@/ui/layout/PageTitle';
import { FileUploaderContainer } from '@/ui/fileUploader/FileUploaderContainer';
import { AuthLoginCard } from '@/ui/auth/AuthLoginCard';

function Apprenticeship() {
  const userStore = useUserStore();

  return (
    <Page withHeader={!!userStore.user}>
      {userStore.user ? (
        <>
          <PageTitle title="UPLOADER" />
          <FileUploaderContainer />
        </>
      ) : (
        <AuthLoginCard />
      )}
    </Page>
  );
}

export const getStaticProps: GetStaticProps = async () => ({
  props: {},
});

export default Apprenticeship;
